import { useContext, useState, memo, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from './data/MenuItems';
import DirectLink from './components/DirectLink';
import SubLink from './components/SubLink';
import { IsListNotEmpty, GetURLPath } from '@utils';
import './style.css';
import { PrivilegeContext } from '@context/PrivilegesContext';
import { CRRender } from '@comp/crRender';


const homeScreen = {
    icon: "fluent:home-20-regular",
    name: "home",
    path: "/",
    id: [0]
}

const Sidebar = () => {

    const [subOpendedScreens, setSubOpendedScreens] = useState(GetURLPath())
    const [isMenuOpened, toggleIsMenuOpened] = useState(false)


    const { authorizedPages, isHaveScreens = IsListNotEmpty(authorizedPages) } = useContext(PrivilegeContext)

    const navigate = useNavigate()


    const { setPatheName } = useContext(PrivilegeContext)

    const handleDirectLinks = (path, subOpened = null) => {
        navigate(path)
        setPatheName(path)
        setSubOpendedScreens(subOpened)
    }



    return (
        <nav id="sidebar" className={` active pointer`} >

            <ul className="list-unstyled components">
                <DirectLink isMenuOpened={isMenuOpened} screen={homeScreen} handleNavigate={handleDirectLinks} />

                <CRRender isRender={isHaveScreens}>
                    {Menu.mapWithKey(screen => (
                        <Fragment key={screen.key}>
                            <SubLink isMenuOpened={isMenuOpened} screen={screen} subOpendedScreens={subOpendedScreens} handleNavigate={handleDirectLinks} />
                            <DirectLink isMenuOpened={isMenuOpened} screen={screen} handleNavigate={handleDirectLinks} />
                        </Fragment>)
                    )}
                </CRRender>
            </ul>
        </nav >
    );
}

export default memo(Sidebar);
